import { z } from 'zod';
import { ActorSchema } from '../common/actor.schema';
import { ValuationViewingKindSchema } from '../valuation/valuation-agent-result.schemas';
import { ValuationAgentRequestKindSchema } from '../valuation/valuation-agent-request.schemas';

/** Bus event for the valuation agent's delivered result (IMM-1391). Figures and ids only. */
export const ValuationAgentResultDeliveredPayloadSchema = z.object({
  resultId: z.uuid(),
  requestId: z.uuid(),
  workspaceId: z.uuid(),
  propertyId: z.uuid(),
  dealId: z.uuid().nullable(),
  kind: ValuationAgentRequestKindSchema,
  priceFrom: z.number(),
  priceTo: z.number(),
  recommendedStartPrice: z.number().nullable(),
  withAssumptions: z.boolean(),
  viewingKind: ValuationViewingKindSchema.nullable(),
  documentId: z.uuid(),
  supersededResultId: z.uuid().nullable(),
  agentTokenId: z.uuid(),
  actor: ActorSchema,
  occurredAt: z.iso.datetime(),
});
export type ValuationAgentResultDeliveredPayload = z.infer<typeof ValuationAgentResultDeliveredPayloadSchema>;
